import styles from './statistic-modal.module.scss'

export default function SendStatisticStepOne({ onFoundYes, onFoundNo, surveyData }) {
  const userName = surveyData?.name || 'Seafarer'

  return (
    <div className={styles['statisticStepOne']}>
      <b>📢 Quick Check-In: Have You Found a Job?</b>
      <p>
        Hello {userName}, We noticed you haven't logged in for a few days. Have you already found a job, or are you
        still looking? Let us know – it helps us improve our services and connect you with the best opportunities!
      </p>
      <div className={styles['statisticStep__buttons']}>
        <button onClick={onFoundYes} className={styles['statisticStep__button']}>
          Yes, I've found a job
        </button>
        <button onClick={onFoundNo} className={styles['statisticStep__button']}>
          No, I'm still looking
        </button>
      </div>
      <span>Your feedback helps us provide better job opportunities for seafarers like you.</span>
    </div>
  )
}
